export type AlpacaAccountStatus =
  | 'SUBMITTED'
  | 'ACTION_REQUIRED'
  | 'APPROVAL_PENDING'
  | 'APPROVED'
  | 'REJECTED'
  | 'ACTIVE'
  | 'DISABLED'
  | 'ACCOUNT_CLOSED';

export enum CryptoStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  SUBMISSION_FAILED = 'SUBMISSION_FAILED',
  PAPER_ONLY = 'PAPER_ONLY',
  APPROVED = 'APPROVED',
}

export interface TradingAccount {
  id: string;
  account_number: string;
  status: AlpacaAccountStatus;
  crypto_status: CryptoStatus;
  currency: string;
  buying_power: string;
  regt_buying_power: string;
  cash: string;
  cash_withdrawable: string;
  cash_transferable: string;
  accrued_fees: string;
  pending_transfer_out: string;
  portfolio_value: string;
  trading_blocked: boolean;
  transfers_blocked: boolean;
  account_blocked: boolean;
  created_at: string;
  trade_suspended_by_user: boolean;
  multiplier: string;
  shorting_enabled: boolean;
  equity: string;
  last_equity: string;
  long_market_value: string;
  short_market_value: string;
  initial_margin: string;
  maintenance_margin: string;
  last_maintenance_margin: string;
  sma: string;
  previous_close: string;
  last_long_market_value: string;
  last_short_market_value: string;
  last_cash: string;
  last_initial_margin: string;
  last_regt_buying_power: string;
  last_buying_power: string;
  clearing_broker: string;
}

export interface Position {
  asset_id: string;
  symbol: string;
  exchange: string;
  asset_class: string;
  avg_entry_price: string;
  qty: string;
  side: string;
  market_value: string;
  cost_basis: string;
  unrealized_pl: string;
  unrealized_plpc: string;
  unrealized_intraday_pl: string;
  unrealized_intraday_plpc: string;
  current_price: string;
  lastday_price: string;
  change_today: string;
  metadata?: {
    name?: string;
    image?: string;
  }
}

export interface PortfolioHistory {
  timestamp: number[];
  equity: number[];
  profit_loss: number[];
  profit_loss_pct: number[];
  base_value: number;
  timeframe: string;
}

export interface DailyAndWeeklyPortfolioHistory {
  daily: PortfolioHistory;
  weekly: PortfolioHistory;
}

export interface GetPortfolioHistory {
  period?: string;
  timeframe?: string;
  date_end?: Date;
  extended_hours?: boolean;
}

export enum PortfolioPeriodType {
  _1D = '1D',
  _1W = '1W',
  _1M = '1M',
  _3M = '3M',
  _1A = '1A',
  _2A = '2A',
  _5Y = '5Y',
}
